<script>
	import Header from './Header.svelte'
	import Row from './Row.svelte'

	export let specs
	export let models
	export let thisPage = 'pro'
	
	let otherModels = []
	let active = models.filter(x => x !== thisPage)[0]
	let ww
	let mobile

	const filterModels = current => {
		const filtered = models.filter(x => x !== current)
		active = filtered[0]
		
		return filtered
	}
			
	$: otherModels = filterModels(thisPage)
	$: mobile = ww < 888
</script>

<svelte:window bind:innerWidth={ww}></svelte:window>

<div class="tabelka">
	<Header
		{thisPage} {otherModels} {active} {mobile}
		on:newActive={e => active = e.detail}
	/>
	
	{#each specs as rzadek}
		{@const specName = Object.keys(rzadek)[0]}

		<Row {specName} {rzadek} {mobile} {thisPage} {active} {otherModels} />
	{/each}
</div>
	
<style>
	.tabelka {
		width: 100%;
		position: relative
	}
</style>